import { createUseI18n } from '@funtech-int/yango-shared';

import { dictionary } from '@/scenarios/home/i18n/faq';

export const useI18n = createUseI18n(dictionary);

// ts-prune-ignore-next
export type I18n = ReturnType<typeof useI18n>;
